import { PaymentStatus } from 'api/models/payload/ClientsPayload';

export const CLIENT_PAYMENT_STATUSES: PaymentStatus[] = [
    PaymentStatus.NOT_PAID,
    PaymentStatus.PARTIALLY_PAID,
    PaymentStatus.FULLY_PAID,
];

export const CLIENT_PAYMENT_STATUS_LABEL_KEYS: Record<PaymentStatus, string> = {
    [PaymentStatus.NOT_PAID]: 'paymentStatusNotPaid',
    [PaymentStatus.PARTIALLY_PAID]: 'paymentStatusPartiallyPaid',
    [PaymentStatus.FULLY_PAID]: 'paymentStatusFullyPaid',
};

export const CLIENT_PAYMENT_STATUS_ICON_FILL: Record<PaymentStatus, string> = {
    [PaymentStatus.NOT_PAID]: '#CCCCCC',
    [PaymentStatus.PARTIALLY_PAID]: '#ca8a04',
    [PaymentStatus.FULLY_PAID]: 'rgb(17, 123, 52)',
};

export const CLIENT_PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
    [PaymentStatus.NOT_PAID]: 'rgb(50, 56, 66)',
    [PaymentStatus.PARTIALLY_PAID]: 'rgb(202, 138, 4)',
    [PaymentStatus.FULLY_PAID]: 'rgb(17, 123, 52)',
};

/** Treat missing/unknown API values as unpaid so the UI always has a valid status. */
export const normalizeClientPaymentStatus = (status: string | null | undefined): PaymentStatus => {
    if (status === PaymentStatus.PARTIALLY_PAID || status === PaymentStatus.FULLY_PAID) {
        return status;
    }
    return PaymentStatus.NOT_PAID;
};
